import { Injectable } from '@angular/core';
import {
  ALLOWED_LAUNCH_PARAMS,
  LAUNCH_PARAMS_STORAGE_KEY,
  LaunchOverrides,
} from '../models/dtr-types';

@Injectable({
  providedIn: 'root',
})
export class LaunchParamsService {
  // Assumes PathLocationStrategy — if hash routing is added, also parse location.hash
  resolveOverrides(search = window.location.search): LaunchOverrides {
    const params = new URLSearchParams(search);

    if (params.has('iss')) {
      this.validateParamNames(params);
      const overrides = this.extractOverrides(params);
      this.persistOverrides(overrides);
      return overrides;
    }

    return this.loadStoredOverrides();
  }

  private validateParamNames(params: URLSearchParams): void {
    const allowed = new Set<string>(ALLOWED_LAUNCH_PARAMS);
    for (const key of params.keys()) {
      if (!allowed.has(key)) {
        console.warn(
          `Ignoring unrecognized URL parameter: '${key}'. Allowed parameters: ${ALLOWED_LAUNCH_PARAMS.join(', ')}`,
        );
      }
    }
  }

  private extractOverrides(params: URLSearchParams): LaunchOverrides {
    const overrides: LaunchOverrides = {};
    if (params.has('standalone')) overrides.standalone = params.get('standalone')!;
    if (params.has('useHook')) overrides.useHook = params.get('useHook')!;
    return overrides;
  }

  private persistOverrides(overrides: LaunchOverrides): void {
    if (Object.keys(overrides).length > 0) {
      sessionStorage.setItem(LAUNCH_PARAMS_STORAGE_KEY, JSON.stringify(overrides));
    } else {
      sessionStorage.removeItem(LAUNCH_PARAMS_STORAGE_KEY);
    }
  }

  private loadStoredOverrides(): LaunchOverrides {
    const stored = sessionStorage.getItem(LAUNCH_PARAMS_STORAGE_KEY);
    if (!stored) return {};
    try {
      return JSON.parse(stored) as LaunchOverrides;
    } catch {
      return {};
    }
  }
}
